module.exports = __webpack_public_path__ + "static/img/icon4-5.03342ff9.png";